// extracted by mini-css-extract-plugin
export var avatar = "_oe-3";
export var avatarContainer = "_oe-2";
export var avatarSpacer = "_oe-5";
export var avatarSpacerContainer = "_oe-4";
export var avatarStackContainer = "_oe-1";
export var bubble = "_oe-0";
export var remainderBubble = "_oe-6";